// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"styles_gridContainer__34z_p","newUsersGridContainer":"styles_newUsersGridContainer__167Js"};